import React from 'react';

const SvgIcon = () => (
  <svg viewBox="0 0 61.04 40.33" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <style>{`
        .cls-1 { fill: #2a2d34; }
        .cls-2 { fill: none; stroke: #2a2d34; stroke-width: 2.83px; stroke-linejoin: round; }
        .cls-3 { fill: none; stroke: #2a2d34; stroke-width: 0.98px; stroke-linecap: round; stroke-linejoin: round; }
      `}</style>
    </defs>

    <rect
      className="cls-3"
      x="2.31"
      y="2.3"
      width="56.45"
      height="35.73"
      rx="2.59"
      ry="2.59"
    />
    <line className="cls-2" x1="2.28" y1="13.78" x2="58.38" y2="13.78" />
    <line className="cls-2" x1="42.19" y1="2.55" x2="42.19" y2="37.5" />
    <path
      className="cls-1"
      d="M30.37,25.49c.46-2.44.91-4.82,1.37-7.19.04-.19.18-.38.33-.51,1.23-1.06,2.47-2.1,3.7-3.15.13-.11.28-.2.51-.36-.79-.14-1.51-.22-2.2-.4-1.13-.29-2.26-.58-3.35-.98-.89-.33-.94-.56-.77-1.48.21-1.16.41-2.33.6-3.5.11-.67.35-.84,1.01-.68,3.12.76,6.02,2.01,8.75,3.73.65.41,1.6.4,2.41.46.66.05,1.26-.23,1.84-.61,2.53-1.66,5.3-2.77,8.23-3.47.71-.17.92-.03,1.05.68.24,1.28.44,2.57.68,3.85.1.52-.15.83-.57.98-1.05.37-2.1.73-3.17,1.02-.87.23-1.76.33-2.73.51.5.37.98.69,1.41,1.05.93.79,1.84,1.6,2.73,2.43.19.17.32.46.37.71.46,2.28.9,4.57,1.36,6.97-.17-.15-.26-.23-.35-.32-1.88-1.74-3.71-3.54-5.65-5.21-1.6-1.37-2.8-3-3.74-4.84-.19-.36-.42-.59-.81-.62-.81-.06-1.62-.11-2.43-.16-.36-.02-.53.19-.72.49-.81,1.28-1.55,2.62-2.53,3.76-.87,1.02-2.05,1.78-3.04,2.71-1.36,1.27-2.68,2.59-4.02,3.89-.07.07-.15.13-.27.24"
    />
  </svg>
);

export default SvgIcon;
